import { render } from "./CompassView.vue?vue&type=template&id=b3342172"
import script from "./CompassView.vue?vue&type=script&lang=js"
export * from "./CompassView.vue?vue&type=script&lang=js"

import "./CompassView.vue?vue&type=style&index=0&id=b3342172&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__